/**
 * FAQ Accordion Web Component
 * Smooth open/close animation using CSS grid-template-rows
 * Single-open constraint + optional tab filtering
 */
class FaqAccordion extends HTMLElement {
  connectedCallback() {
    this.items = this.querySelectorAll('.support-faq__item');
    this.tabs = this.querySelectorAll('.support-faq__tab');
    this.activeTab = 'general';

    this.items.forEach(item => {
      const summary = item.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', (e) => {
        e.preventDefault();
        if (item.classList.contains('is-closing')) return;

        if (item.open) {
          this.closeItem(item);
        } else {
          this.openItem(item);
        }
      });
    });

    if (this.tabs.length > 0) {
      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => this.switchTab(tab.dataset.tab));
      });
    }
  }

  openItem(item) {
    // Close any other open item first
    this.items.forEach(other => {
      if (other !== item && other.open) this.closeItem(other);
    });

    const wrap = item.querySelector('.support-faq__answer-wrap');

    // Lock grid at 0fr, set open (renders content), force reflow, then release to animate
    if (wrap) wrap.style.gridTemplateRows = '0fr';
    item.open = true;
    if (wrap) {
      wrap.offsetHeight; // force reflow
      wrap.style.gridTemplateRows = '';
    }
  }

  closeItem(item) {
    // Add closing class — CSS keeps grid-template-rows: 0fr while [open] is still true
    item.classList.add('is-closing');

    const wrap = item.querySelector('.support-faq__answer-wrap');
    if (!wrap) {
      item.open = false;
      item.classList.remove('is-closing');
      return;
    }

    const onDone = () => {
      wrap.removeEventListener('transitionend', onDone);
      item.open = false;
      item.classList.remove('is-closing');
    };

    wrap.addEventListener('transitionend', onDone, { once: true });

    // Safety fallback
    setTimeout(onDone, 350);
  }

  switchTab(tabId) {
    this.activeTab = tabId;

    this.tabs.forEach(tab => {
      const isActive = tab.dataset.tab === tabId;
      tab.classList.toggle('support-faq__tab--active', isActive);
      tab.setAttribute('aria-selected', isActive);
    });

    // Instantly close all and show matching tab items
    this.items.forEach(item => {
      item.open = false;
      item.classList.remove('is-closing');
      item.classList.toggle('support-faq__item--visible', item.dataset.tab === tabId);
    });
  }
}

customElements.define('faq-accordion', FaqAccordion);
